:host {
  @apply inline-flex justify-center;
}

.pk-tab__button {
  @include transition(#{color, background-color});

  @apply button-reset flex flex-grow select-none items-center justify-center  bg-[color:--tab--button-background] text-[color:--tab--color];
  @apply relative min-h-[40px] pb-[7px] pl-s pr-s pt-[9px] text-[length:--tabs--font-size] leading-s;
  @apply focus:outline-none focus-visible:outline-none;

  font-family: var(--tabs--font-family);

  &::after {
    @apply absolute bottom-0 left-0 block h-[3px] w-full origin-left scale-x-0 content-[''];
    @apply transition-transform duration-250 ease-linear;
  }

  &:hover {
    @apply cursor-pointer text-[color:--tab--color-hover];

    &::after {
      @apply scale-x-100 bg-[color:--tab--color-hover];
    }

    ::slotted([slot='icon']) {
      @apply [--icon--color:--tab--color-hover];
    }
  }

  &:focus-visible {
    @apply bg-ui-02;

    ::slotted([slot='icon']) {
      @apply [--icon--color:--tab--color-focus];
    }
  }

  &:active,
  &.active {
    @apply text-[color:--tab--color-active];

    &::after {
      @apply scale-x-100 bg-[color:--tab--color-active];
    }

    ::slotted([slot='icon']) {
      @apply [--icon--color:--tab--color-active];
    }
  }

  &[disabled] {
    @apply pointer-events-none opacity-40;
  }

  ::slotted([slot='icon']) {
    @apply mr-xs;
  }
}

.selected-tab {
  @apply border-0 border-b-[3px] border-solid border-b-[color:--tabs--selected-color];

  button {
    @apply pb-[3px] text-[color:--tab--selected-color];
  }

  ::slotted([slot='icon']) {
    @apply [--pk-icon--color:--tab--selected-color];
  }
}
